import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Undertaking, UndertakingType } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { TagsSelector } from '@state/global/tags/tags.selector';
import { UndertakingsDispatch } from '@state/matter/undertakings';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, take } from 'rxjs/operators';
import { ICON } from '@core/util/icon';
import { UndertakingDialogComponent } from '../undertaking-dialog';
import { UrlService } from '@services/url/url.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';

@UntilDestroy()
@Component({
	selector: 'app-undertaking-item',
	templateUrl: './undertaking-item.component.html',
	standalone: false,
})
export class UndertakingItemComponent {
	public parsedText: string;
	public currentUndertaking: Undertaking;
	public ICON = ICON;
	public childUrl = '';
	public relatedInstrumentsParsedText = {};
	@Input() set undertaking(undertaking: Undertaking) {
		this.currentUndertaking = undertaking;

		if (undertaking) {
			this.getParsedDocument$(undertaking.text)
				.pipe(distinctUntilChanged(), take(2)) //We use distinctUntilChange since the first value might be wrong if tag have not load on time
				.subscribe((result) => {
					this.parsedText = result;
				});

			if (undertaking.relatedInstruments) {
				Object.entries(undertaking.relatedInstruments).forEach(
					([key, value]) => {
						this.getParsedDocument$(value.text)
							.pipe(distinctUntilChanged(), take(2))
							.subscribe((result) => {
								this.relatedInstrumentsParsedText[key] = result;
							});
					},
				);
			}
			if (undertaking.type === UndertakingType.ENCUMBRANCE) {
				this.childUrl = UrlService.Matter_Encumbrances_Encumbrance(
					this.matterId,
					undertaking.join,
				);
			}
			if (undertaking.type === UndertakingType.DEBT) {
				this.childUrl = UrlService.Matter_Debts(this.matterId);
			}
		}
	}

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(TagsSelector.getTagInjectedDocument)
	parsedDocumentFilterFn$: Observable<(doc: string) => string>;
	constructor(
		private undertakingsDispatch: UndertakingsDispatch,
		private dialog: MatDialog,
	) {}

	editUndertaking(undertaking: Undertaking): void {
		this.openUndertakingDialog(undertaking.id);
	}

	removeUndertaking(undertaking: Undertaking): void {
		this.undertakingsDispatch.Remove(undertaking.id);
	}

	getParsedDocument$(document: string) {
		return this.parsedDocumentFilterFn$.pipe(map((filter) => filter(document)));
	}

	private openUndertakingDialog(undertakingId: string = ''): void {
		this.dialog.open(UndertakingDialogComponent, {
			autoFocus: true,
			data: {
				undertakingId,
			},
			maxHeight: '100%',
			maxWidth: '500px',
			minWidth: '300px',
			width: '50%',
		});
	}
}
